import { hasCrmPermissions } from "app/components/SideBar/utils";
import { SI_ROOT_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import {
    HS_MANAGEMENT_ENRICHMENT_LOGS_ROUTE,
    HS_MANAGEMENT_JOB_ENRICHMENT_EDIT_ROUTE,
    HS_MANAGEMENT_MANAGE_ROUTE,
    HS_MANAGEMENT_MANAGE_URL,
    HS_MANAGEMENT_ROOT_ENRICHMENT_ROUTE,
    HS_MANAGEMENT_ROOT_ROUTE_EXPORT,
} from "app/pages/sales-intelligence/constants/sl_routes";
import HsEnrichmentJobEditContainer from "app/pages/sales-intelligence/pages/crm-enrichment/containers/CrmEnrichmentJobEditContainer/HsEnrichmentJobEditContainer";
import HsEnrichmentJobWizardContainer from "app/pages/sales-intelligence/pages/crm-enrichment/containers/CrmEnrichmentJobWizardContainer/HsEnrichmentJobWizardContainer";
import EnrichmentLogsPageContainer from "app/pages/sales-intelligence/pages/crm-enrichment/containers/EnrichmentLogsPageContainer/EnrichmentLogsPageContainer";
import ManageExport from "app/pages/sales-intelligence/pages/manage-export/ManageExport";
import ManageIntegration from "app/pages/sales-intelligence/pages/manage-integration/ManageIntegration";
import type { SecondaryBarType } from "app/reducers/_reducers/SecondaryBarReducer";
import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

export const hubspotConfig: RouterStateConfig = {
    [HS_MANAGEMENT_MANAGE_ROUTE]: {
        parent: SI_ROOT_ROUTE,
        url: HS_MANAGEMENT_MANAGE_URL,
        // @ts-ignore FIXME: strict migration - Type 'unknown' is not assignable to type 'ComponentType<any>' — redux compose() return type collapses to unknown beyond ~4 HOCs
        component: ManageIntegration,
        configId: "SalesWorkspace",
        stateId: HS_MANAGEMENT_MANAGE_ROUTE,
        trackingId: {
            section: "SI_admin",
            subSection: "integrations",
            subSubSection: "manage hubspot",
        },
        pageTitle: "si.pages.management.document_title",
        isSecondaryBarOpen: false,
        secondaryBarType: "SalesIntelligenceManagement" as SecondaryBarType,
        isHidden: hasCrmPermissions(),
    },
    [HS_MANAGEMENT_ROOT_ROUTE_EXPORT]: {
        parent: SI_ROOT_ROUTE,
        url: `${HS_MANAGEMENT_MANAGE_URL}/export`,
        // @ts-ignore FIXME: strict migration - Type 'unknown' is not assignable to type 'ComponentType<any>' — redux compose() return type collapses to unknown beyond ~4 HOCs
        component: ManageExport,
        configId: "SalesWorkspace",
        trackingId: {
            section: "SI_admin",
            subSection: "integrations",
            subSubSection: "manage hubspot",
        },
        pageTitle: "si.pages.management.document_title",
        isSecondaryBarOpen: false,
        secondaryBarType: "SalesIntelligenceManagement" as SecondaryBarType,
        isHidden: hasCrmPermissions(),
    },
    [HS_MANAGEMENT_ROOT_ENRICHMENT_ROUTE]: {
        parent: SI_ROOT_ROUTE,
        url: `${HS_MANAGEMENT_MANAGE_URL}/enrichment`,
        // @ts-ignore FIXME: strict migration - Type 'unknown' is not assignable to type 'ComponentType<any>' — redux compose() return type collapses to unknown beyond ~4 HOCs
        component: HsEnrichmentJobWizardContainer,
        configId: "SalesWorkspace",
        trackingId: {
            section: "SI_admin",
            subSection: "integrations",
            subSubSection: "edit hubspot enrichment",
        },
        pageTitle: "si.pages.management.document_title",
        isSecondaryBarOpen: false,
        secondaryBarType: "SalesIntelligenceManagement" as SecondaryBarType,
        isHidden: hasCrmPermissions(),
    },
    [HS_MANAGEMENT_JOB_ENRICHMENT_EDIT_ROUTE]: {
        parent: SI_ROOT_ROUTE,
        url: `${HS_MANAGEMENT_MANAGE_URL}/enrichment/:id`,
        // @ts-ignore FIXME: strict migration - Type 'unknown' is not assignable to type 'ComponentType<any>' — redux compose() return type collapses to unknown beyond ~4 HOCs
        component: HsEnrichmentJobEditContainer,
        configId: "SalesWorkspace",
        trackingId: {
            section: "SI_admin",
            subSection: "integrations",
            subSubSection: "edit hubspot enrichment",
        },
        pageTitle: "si.pages.management.document_title",
        isSecondaryBarOpen: false,
        secondaryBarType: "SalesIntelligenceManagement" as SecondaryBarType,
        isHidden: hasCrmPermissions(),
    },
    [HS_MANAGEMENT_ENRICHMENT_LOGS_ROUTE]: {
        parent: SI_ROOT_ROUTE,
        url: `${HS_MANAGEMENT_MANAGE_URL}/enrichment/logs/:jobId`,
        // @ts-ignore FIXME: strict migration - Type 'unknown' is not assignable to type 'ComponentType<any>' — redux compose() return type collapses to unknown beyond ~4 HOCs
        component: EnrichmentLogsPageContainer,
        configId: "SalesWorkspace",
        trackingId: {
            section: "SI_admin",
            subSection: "integrations",
            subSubSection: "hubspot enrichment logs",
        },
        pageTitle: "si.pages.management.document_title",
        isSecondaryBarOpen: false,
        secondaryBarType: "SalesIntelligenceManagement" as SecondaryBarType,
        isHidden: hasCrmPermissions(),
    },
};
